import React from 'react'
import * as Sections from './index'

const BlockWrapper = ({ blocks, theme }) => {
  return (
    <>
      {blocks.map((block, index) => {
        const Component = Sections[block.__typename]
        if (!Component) return null

        return (
          <Component
            key={block.__typename + block.id}
            index={index}
            theme={theme}
            {...block}
          />
        )
      })}
    </>
  )
}

export default BlockWrapper
